import { componentStylesToCss } from '../componentStylesUtils';

const stylesInputUrlSearchParamSwitch = (componentStyles) => `
  .inputUrlSearchParamSwitch-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  .inputUrlSearchParamSwitch-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
  }

  .inputUrlSearchParamSwitch-track {
    width: 42px;
    height: 12px;
    border-radius: 16px;
    ${componentStylesToCss(componentStyles?.wrapper)}
  }

  .inputUrlSearchParamSwitch-track-on {
     background-color: #6F0035;
  }

  .inputUrlSearchParamSwitch-track-off {
    background-color: #AAAAAA;
  }

  .inputUrlSearchParamSwitch-thumb {
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    top: calc(50% - 20px/2);
    
    /* Backgorund/Text */
    background: #FCFCFC;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.24);
  }

  .inputUrlSearchParamSwitch-thumb-on {
    right: calc(-42px + 20px);
  }

  .inputUrlSearchParamSwitch-thumb-off {
    right: 0px;
  }
`;

export default stylesInputUrlSearchParamSwitch;
